import {
    CREATE_TEMPLATE_FAIL,
    CREATE_TEMPLATE_REQUEST,
    CREATE_TEMPLATE_RESET,
    CREATE_TEMPLATE_SUCCESS,
    DELETE_TEMPLATE_REQUEST,
    DELETE_TEMPLATE_SUCCESS,
    DELETE_TEMPLATE_FAIL,
    DELETE_TEMPLATE_RESET,
    GET_TEMPLATE_CONTENT_FAIL,
    GET_TEMPLATE_CONTENT_REQUEST,
    GET_TEMPLATE_CONTENT_RESET,
    GET_TEMPLATE_CONTENT_SUCCESS,
    GET_USER_TEMPLATES_FAIL,
    GET_USER_TEMPLATES_REQUEST,
    GET_USER_TEMPLATES_RESET,
    GET_USER_TEMPLATES_SUCCESS,
    UPDATE_TEMPLATE_FAIL,
    UPDATE_TEMPLATE_REQUEST,
    UPDATE_TEMPLATE_RESET,
    UPDATE_TEMPLATE_SUCCESS
} from '../constants/templateConstants';

export const getUserTemplatesReducer = (state = { }, action) => {
    switch(action.type) {
        case GET_USER_TEMPLATES_REQUEST:
            return {userTemplatesLoading:true, userTemplates: { templates: [] } }

        case GET_USER_TEMPLATES_SUCCESS:
            return {userTemplatesLoading:false, userTemplates: action.payload }

        case GET_USER_TEMPLATES_FAIL:
            return {userTemplatesLoading:false, userTemplatesLoadingError: action.payload }

        case GET_USER_TEMPLATES_RESET:
            return {userTemplatesLoading:false, userTemplates: null }

        default:
            return state
    }
}

export const getTemplateContentReducer = (state = { }, action) => {
    switch(action.type) {
        case GET_TEMPLATE_CONTENT_REQUEST:
            return {templateContentLoading: true}

        case GET_TEMPLATE_CONTENT_SUCCESS:
            return {templateContentLoading: false, templateContent: action.payload}

        case GET_TEMPLATE_CONTENT_FAIL:
            return {templateContentLoading: false, templateContentError: action.payload}

        case GET_TEMPLATE_CONTENT_RESET:
            return { templateContentLoading: false, templateContent: null }
            
        default: return state
    }
}

export const getTemplateCreateReducer = (state = { }, action) => {
    switch(action.type) {
        case CREATE_TEMPLATE_REQUEST:
            return { templateCreating: true }

        case CREATE_TEMPLATE_SUCCESS:
            return { templateCreating: false,templateCreated: true }

        case CREATE_TEMPLATE_FAIL:
            return { templateCreating: false }

        case CREATE_TEMPLATE_RESET:
            return { templateCreating: false, templateCreated: false }

        default: return state
    }
}

export const getTemplateUpdateReducer = (state = { }, action) => {
    switch(action.type) {
        case UPDATE_TEMPLATE_REQUEST:
            return { templateUpdating: true }

        case UPDATE_TEMPLATE_SUCCESS:
            return { templateUpdating: false, templateUpdated: true }

        case UPDATE_TEMPLATE_FAIL:
            return { templateUpdating: false }

        case UPDATE_TEMPLATE_RESET:
            return { templateUpdating: false, templateUpdated: false }

        default: return state
    }
}

export const getTemplateDeleteReducer = (state = { }, action) => {
    switch(action.type) {
        case DELETE_TEMPLATE_REQUEST:
            return { templateDeleting: true, templateDeleteError: null }

        case DELETE_TEMPLATE_SUCCESS:
            return { templateDeleting: false, templateDeleteError: null, templateDeleted: true }

        case DELETE_TEMPLATE_FAIL:
            return { templateDeleting: false, templateDeleteError: action.payload }

        case DELETE_TEMPLATE_RESET:
            return { templateDeleting: false, templateDeleteError: null, templateDeleted: false }

        default: return state
    }
}
